<template>
  <div>
    <ScheduleRow
      v-for="(schedule, index) in sortedItems"
      :key="schedule.id"
      :schedule="schedule"
      :class="{
        'border-gray border-b first:border-t':
          schedule.color === null &&
          (sortedItems[index + 1]?.color === null ||
            sortedItems[index + 1]?.color === undefined),
        '-mx-5': !!schedule.color?.length,
      }"
    />

    <ShowMoreButton
      v-if="hasMore"
      type="border"
      class="mt-7.5 xl:mt-10"
      button-color="dark"
      @click="$emit('load-more')"
    />
  </div>
</template>

<script setup lang="ts">
import type { Schedule } from '~/types'

const props = defineProps<{
  items: Schedule[]
  hasMore?: boolean
}>()
const sortedItems = computed(() =>
  [...props.items].sort((a, b) => Number(a.id) - Number(b.id)),
)

defineEmits<{
  (e: 'load-more'): void
}>()
</script>
